import firebase from 'firebase/app'
import 'firebase/firestore'

const firebaseConfig = {
    apiKey: "AIzaSyA3J0zNP7F-95Vu0-HK9Q-7O8IuKZn2x3U",
    authDomain: "cooking-ninja-site-7fce3.firebaseapp.com",
    projectId: "cooking-ninja-site-7fce3",
    storageBucket: "cooking-ninja-site-7fce3.appspot.com",
    messagingSenderId: "417848406702",
    appId: "1:417848406702:web:08e38e3759224f9249b33f"
  };

  // init firebase
  firebase.initializeApp(firebaseConfig)

  // init services
  const projectFirestore = firebase.firestore()

  export { projectFirestore }